<template>
  <el-dialog width="420px" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="visible"
    :show-close="hasClose" :title="step === 1 ? '快速查找' : '请确认考生信息'" center @close="hide">
    <div v-show="step === 1" class="search-box">
      <el-form class="form" ref="form" :model="form" :rules="rules" @submit.native.prevent>
        <el-form-item prop="userId">
          <el-input v-model.trim="form.userId" :maxlength="11" autocomplete="off" placeholder="请输入考生账号ID"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" :loading="loading" @click="onNext">下一步</el-button>
    </div>
    <div v-show="step === 2" class="user-info">
      <p class="tips" v-show="hasUnjudged">当前存在未完成的评审任务，请先完成！</p>
      <div class="flex-row-center">
        <span>考生账号ID</span>
        <span>考生姓名</span>
      </div>
      <div class="flex-row-center">
        <span>{{ form.userId }}</span>
        <span>{{ form.userName }}</span>
      </div>
      <el-button class="btn-enter" type="primary" size="small" :loading="loading" @click="toJudge">
        {{ hasUnjudged ? '继续' : '进入' }}评审
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, Form, FormItem, Input, Button } from 'element-ui'
import { get, post } from '@/utils/ajax'

export default {
  components: {
    ElDialog: Dialog,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button
  },
  props: {
    judgeId: String,
    markingId: String,
    examineeUserId: String
  },
  data() {
    const checkCurrentUser = (rule, value, callback) => {
      if (+value === +this.examineeUserId) {
        callback(new Error('正在批阅该考生试卷'))
      }
      callback()
    }

    return {
      visible: false,
      hasClose: false, // 是否显示关闭按钮
      loading: false,
      step: 1,
      form: {
        userId: '',
        userName: ''
      },
      rules: {
        userId: [
          { required: true, message: '请输入考生账号ID' },
          { pattern: /^[1-9]\d*$/, message: '考生账号ID输入格式不正确' },
          { validator: checkCurrentUser }
        ]
      },
      hasUnjudged: false
    }
  },
  methods: {
    // 显示弹窗
    show(hasClose = false) {
      this.hasClose = hasClose
      this.visible = true
    },
    // 显示弹窗，强制到未完成的考生确认
    showAlert(data) {
      this.form = data
      this.step = 2
      this.hasUnjudged = true
      this.hasClose = false
      this.visible = true
    },
    hide() {
      this.step = 1
      this.hasUnjudged = false
      this.$refs.form && this.$refs.form.resetFields()
      this.visible = false
    },
    // 下一步
    async onNext() {
      try {
        await this.$refs.form.validate()
        this.fetchExamineeInfo()
      } catch (e) { }
    },
    // 拉取考生信息
    async fetchExamineeInfo(data) {
      try {
        this.loading = true
        this.form.userName = await get(`/home/markingAll/judge/${this.judgeId}/marking/${this.markingId}/examinees/${this.form.userId}`, null, { ignoreMsg: true })
        this.loading = false
        this.step = 2
      } catch (e) {
        this.loading = false
        this.errorHandler(e)
      }
    },
    // 分配该考生任务给阅卷老师，并且进入评审
    async toJudge() {
      try {
        const params = {
          judgeId: this.judgeId,
          examineUserId: this.form.userId
        }
        this.loading = true
        await post(`/home/markingAll/judge/bind/examine`, params, { ignoreMsg: true })
        this.loading = false
        this.step = 2
        this.$emit('success', this.form)
      } catch (e) {
        this.loading = false
        this.errorHandler(e)
      }
    },
    // 错误处理
    errorHandler(e) {
      if (e.error_code === 20626010) {
        this.$message.error('该考生的答卷已完成全部评分，无需再次评审')
        this.step = 1
      } else if ([20601004, 20626011].includes(e.error_code)) {
        this.$message.error('该考生账号ID不存在')
      } else if (e.error_code === 20626012) {
        const user = e.error_msg.split(',')
        this.hasUnjudged = true
        this.step = 2
        this.form = {
          userId: user[1],
          userName: user[0]
        }
      } else {
        this.$message.error(e.error_msg || '请求网络异常')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  text-align: center;

  .title {
    font-size: 18px;
    color: #303133;
  }

  .form {
    margin-bottom: 35px;
  }
}

.user-info {
  text-align: center;
  line-height: 40px;
  font-size: 16px;

  span {
    width: 150px;
  }

  .tips {
    color: #F56C6C;
  }

  .btn-enter {
    margin-top: 35px;
  }
}
</style>
